<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <router-link to="/home">
        <img class="home-icon" src="./home.svg" alt="" />
      </router-link>
    </el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index">
      <span
        class="disabled"
        :class="index === breadcrumbs.length - 1 ? 'current-item' : 'item'"
        v-if="item.meta.isDirectory || index === breadcrumbs.length - 1"
        >{{ $t(item.meta.title) }}</span
      >
      <router-link class="h-link" v-else :to="{ path: item.path }">
        <span style="line-height: 22px">{{ $t(item.meta.title) }}</span>
      </router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script setup>
import { getGlobalBreadcrumbs } from '@/core/global-data';
import { computed } from 'vue';

const breadcrumbs = computed(() => {
  return getGlobalBreadcrumbs();
});
</script>

<style scoped lang="scss">
.disabled {
  cursor: not-allowed;
  line-height: 22px;
}

.h-link {
  cursor: pointer;
  font-weight: 400;
  color: #4e5969;
}

.current-item {
  font-weight: 500;
  color: #1d2129;
}

.separator {
  margin: 0 9px;
  font-weight: bold;
  font-size: 14px;
  color: var(--el-text-color-placeholder);
}

.home-icon {
  width: 20px;
  cursor: pointer;
}
</style>
